import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useApp } from "../../../contexts/AppContext";
import { isRtlLanguage } from "../../../utils";

const LineWithArrowsContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  bottom: 20,
  position: "relative",
}));

const Line = styled(Box)(({ theme }) => ({
  height: 4,
  backgroundColor: "#E7E5E4",
  width: "100%",
  position: "relative",
  
}));

const Arrow = styled(Box)(({ theme }) => ({
  width: 0,
  height: 0,
  borderStyle: "solid",
  borderWidth: "6px 6px 0 6px",
  borderColor: `${theme.palette.primary.main} transparent transparent transparent`,
  position: "absolute",
}));

const Label = styled(Box)(({ theme }) => ({
  // position: "absolute",
  color: theme.palette.text.primary,
  
  width: 100,
  "& h6": {
    fontSize: 14,
  }
}));

const LeftLabel = styled(Label)({
  
  paddingLeft: 20,
  "& h6": {
    textAlign: "left",
  }
});

const RightLabel = styled(Label)({
  textAlign: "right",
  paddingRight: 20,
  "& h6": {
    textAlign: "right",
  }
});

interface LineWithArrowsProps {
  leftLabel: string;
  rightLabel: string;
}

const LineWithArrows: React.FC<LineWithArrowsProps> = ({
  leftLabel,
  rightLabel,
}) => {
  const {currentLanguage} = useApp();
  return (
    <LineWithArrowsContainer>
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        direction="row"
        spacing={0}
      >
        <ArrowLeft
          style={{ position: "relative", left: 10, transform: isRtlLanguage(currentLanguage) ? "scaleX(-1)" : "" }}
          size={64}
          color="#E7E5E4"
        />
        <Line />
        <ArrowRight
          style={{ position: "relative", right: 10, transform: isRtlLanguage(currentLanguage) ? "scaleX(-1)" : "" }}
          size={64}
          color="#E7E5E4"
        />
      </Stack>
      <Stack
        alignItems={"center"}
        justifyContent={"space-between"}
        direction="row"
        width={"100%"}
      >
        <LeftLabel>
          <Typography variant="subtitle1">{leftLabel}</Typography>
        </LeftLabel>
        <RightLabel>
          <Typography variant="subtitle1">{rightLabel}</Typography>
        </RightLabel>
      </Stack>
    </LineWithArrowsContainer>
  );
};

export default LineWithArrows;
